'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { ExperimentsPanel } from './experiments-panel';
import { useExperimentsPanelHotkey } from './use-experiments-panel-hotkey';

/**
 * Listens for the hotkey and renders the panel when it fires.
 *
 * Split from `ExperimentsPanel` so the panel itself stays a plain controlled component —
 * easy to render in isolation from a test or a story without a keyboard.
 *
 * Renders nothing until opened, so mounting it globally costs a single keydown listener.
 */
export const ExperimentsPanelMount: React.FC = () => {
  const $ = _c(2);
  const {
    isOpen,
    close
  } = useExperimentsPanelHotkey();
  if (!isOpen) {
    return null;
  }
  let t0;
  if ($[0] !== close) {
    t0 = <ExperimentsPanel isOpen={true} onClose={close} />;
    $[0] = close;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};